import SecondaryLayout from '@/core/layouts/secondary-layout';
import Analytics from '@/modules/analytics/components/Analytics';

const AnalyticsRoute = () => {
  return (
    <SecondaryLayout childrenClassName="max-w-container px-4">
      <Analytics />
    </SecondaryLayout>
  );
};

export default AnalyticsRoute;
